module.exports = __webpack_public_path__ + "img/im_tabledressing.00188bd0.jpg";